import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ConceptSection from './components/ConceptSection';
import MenuSection from './components/MenuSection';
import InfoSection from './components/InfoSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <ConceptSection />
        <MenuSection />
        <InfoSection />
        <ContactSection />
        <Footer />
      </main>
    </>
  );
}